import get from 'lodash/get'
import React from 'react'
import { useSelector } from 'react-redux'
import { useActions } from '../hooks/useActions'
import { useLocalization } from '../redux/reduxHooks.js'
import { renderContent, getLabel, pathToPerson, subQuestions } from '../utils/helpers'
import { PersonFieldPaths } from '../utils/QuestionnaireStateManager.js'
import ConditionalSection from './ConditionalSection'
import DateInput from './DateInput.jsx'
import DeathDetails from './DeathDetails'

export default function LifeStatusWithDoD({ personId, isProband, config }) {
  const localization = useLocalization()
  const lifeStatusDoDOption =
    useSelector((state) =>
      get(state, [...pathToPerson(personId), 'lifeStatus', 'lifeStatusOption']),
    ) || ''

  const { removePersonLifeStatus, setPersonLifeStatus, removePersonProperty } = useActions()
  const { ALIVE_STATUS } = PersonFieldPaths

  const lifeStatusWithDodMap = {
    alive: 'Y',
    deceased: 'N',
    unknown: 'U',
    Y: 'alive',
    N: 'deceased',
    U: 'unknown',
  }

  return (
    <ConditionalSection
      label={getLabel(localization, ALIVE_STATUS)}
      showWhenCondition={isProband ? '' : 'N'}
      conditionState={lifeStatusWithDodMap[lifeStatusDoDOption]}
      onConditionStateChange={(value) => {
        if (value !== lifeStatusWithDodMap[lifeStatusDoDOption]) {
          setPersonLifeStatus({
            id: personId,
            type: 'lifeStatusOption',
            value: lifeStatusWithDodMap[value],
          })
        }
      }}
      orderSchema={['Y', 'N', 'U']}
      cleanUpChildQuestions={() => {
        removePersonLifeStatus({ id: personId, type: 'causeOfDeath' })
        removePersonLifeStatus({ id: personId, type: 'ageOfDeath' })
        removePersonLifeStatus({ id: personId, type: 'postMortemPerformed' })
        removePersonProperty({ id: personId, type: 'dateOfDeath' })
      }}
    >
      <>
        {renderContent({
          renderMap: { dateOfDeath: <DateInput key="dod" id={personId} death /> },
          config,
        })}
        <DeathDetails
          personId={personId}
          localization={localization}
          config={subQuestions({ config, key: 'lifeStatus' })}
        />
      </>
    </ConditionalSection>
  )
}
